import React from 'react'
import {useHistory} from 'react-router-dom'

import {arrow} from '../../resources/Images'

export default function ViewRewards() {
    const history = useHistory()
    return (
        <div className="ViewRewards" onClick={()=>history.push('/rewards')}>
            <div className="ViewRewards__text">
                View your rewards
            </div>
            <div className="ViewRewards__arrow">
                <img loading="lazy" src={arrow} alt=""/>
            </div>
        </div>
    )
}
